var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeleteDocument(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e1eaf6;}.cls-2{fill:url(#linear-gradient);}.cls-3{fill:#a7c1db;}.cls-4{fill:url(#linear-gradient-2);}.cls-5{fill:url(#linear-gradient-3);}.cls-6{fill:#fff;}"), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "linear-gradient",
    x1: 24,
    x2: 24,
    y1: 5.03,
    y2: 40.35
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f1f5f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d8e5f4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "linear-gradient-2",
    x1: 33.99,
    x2: 33.99,
    y1: 21.51,
    y2: 30.34
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ec232b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c92533"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "linear-gradient-3",
    x1: 33.99,
    x2: 33.99,
    y1: 22.24,
    y2: 29.91
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff1c26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e21e2f"
  })))), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 3",
    id: "Layer_3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M33,40.5H15a5,5,0,0,1-5-5v-25a5,5,0,0,1,5-5H27.52a6,6,0,0,1,4.27,1.77l4.44,4.44A6,6,0,0,1,38,16V35.5A5,5,0,0,1,33,40.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M33,42.5H15a5,5,0,0,1-5-5v-25a5,5,0,0,1,5-5H27.52a6,6,0,0,1,4.27,1.77l4.44,4.44A6,6,0,0,1,38,18V37.5A5,5,0,0,1,33,42.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M36,16H30.83a2.33,2.33,0,0,1-2.33-2.33V9.5a.5.5,0,0,1,1,0v4.17A1.33,1.33,0,0,0,30.83,15H36a.5.5,0,0,1,0,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M34,21.43a7.63,7.63,0,1,0,4,14.1v-13A7.62,7.62,0,0,0,34,21.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M41.62,27.05A7.63,7.63,0,1,1,34,19.43,7.64,7.64,0,0,1,41.62,27.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M34,33.68a6.63,6.63,0,1,1,6.63-6.63A6.63,6.63,0,0,1,34,33.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M32.35,27.05l-1.69-1.69.36-.47c.11-.14.24-.28.37-.42s.27-.26.42-.38l.49-.37L34,25.41l1.83-1.83c.17.12.33.23.48.35a3,3,0,0,1,.42.38,5.14,5.14,0,0,1,.38.42,5.41,5.41,0,0,1,.36.5l-1.83,1.82,1.68,1.68c-.12.18-.24.35-.35.49a4.43,4.43,0,0,1-.79.79c-.15.12-.32.24-.5.36L34,28.69l-1.82,1.83c-.19-.12-.35-.24-.5-.35s-.28-.24-.41-.37a6.17,6.17,0,0,1-.74-.92Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteDocument);
export default __webpack_public_path__ + "static/media/delete_document.3d225a60b29c639c874c58e580f0fda7.svg";
export { ForwardRef as ReactComponent };